module.exports = __webpack_public_path__ + "static/media/sign-in-background.090b6157.png";